module.exports = __webpack_public_path__ + "img/trenholm-state-logo.1697f240.jpg";